import * as React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import AppRoot from './AppRoot';

const container = document.getElementById('root');
const root = ReactDOMClient.createRoot(container);
root.render(<AppRoot />);
